import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";

import { LABELS, SUB_TITLES, TITLES, WARNINGS } from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
import { NOTIFY } from "common/config";
const ApiReportsHandler = new ApiReports();

const HighMileageVehicle = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<any>({});
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "indentNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INDENT_NO,
      width: "15%",
    },
    {
      key: "indentDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INDENT_DATE,
      width: "10%",
    },
    {
      key: "vehicleNo",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_NO,
      width: "15%",
    },
    {
      key: "driverName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DRIVER_NAME,
      width: "15%",
    },
    {
      key: "openingKm",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.OPENING_KM,
      width: "10%",
    },
    {
      key: "closingKm",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.CLOSING_KM,
      width: "10%",
    },
    {
      key: "totalFuel",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TOTAL_FUEL,
      width: "10%",
    },
    {
      key: "mileage",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MILEAGE,
      width: "10%",
    },
  ];

  const loadChart = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(
      LABELS.FROM_DATE + ": " + fromDt + "\n" + LABELS.TO_DATE + ": " + toDt
    );
    const args = {
      fromDt,
      toDt,
      reportType: "excel",
    };
    let errors = [];
    if (fromDt == "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt == "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    setChartData(null);
    setRows(null);
    ApiReportsHandler.getHighMileageVehicles(args).then((res) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const list = response.rows;
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setChartData(response);
        setRows(response.rows);
      }
    });
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.HIGH_MILEAGE_VEHICLES}</li>
        </ul>
        <h4>{TITLES.HIGH_MILEAGE_VEHICLES}</h4>
        <p className="SubTitles">{SUB_TITLES.HIGH_MILEAGE_VEHICLES}</p>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div id="chartForm">
            <div
              className="formGroup"
              style={{
                display: "flex",
                marginTop: 5,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn
                  text={LABELS.LOAD}
                  onClick={loadChart}
                  loading={!chartData}
                />
              </div>
            </div>
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={"highMilageVehicles"}
              title={LABELS.HIGH_MILEAGE_VEHICLES}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(HighMileageVehicle);
